"use strict";

/**
|--------------------------------------------------
| Toggle class on a parent element when a child element is collapsed
|--------------------------------------------------
*/

export const toggleCollapseOnParent = function(){
	const collapses = document.querySelectorAll('[data-bs-toggle="collapse"]');
	collapses.forEach(collapse => {
		const targetParent = collapse.closest(collapse.dataset.targetParent);
		if(!targetParent) return;
		const collapseTarget = document.querySelector(collapse.dataset.bsTarget);
		if(!collapseTarget) return;
		let toggleClass = 'show';

		if(collapse.dataset.toggleParentClass){
			toggleClass = collapse.dataset.toggleParentClass;
		}

		collapseTarget.addEventListener('show.bs.collapse', function () {
			targetParent.classList.add(toggleClass);
		});
		collapseTarget.addEventListener('hide.bs.collapse', function () {
			targetParent.classList.remove(toggleClass);
		});
	})
}